import { render, staticRenderFns } from "./ViewVisitorModal.vue?vue&type=template&id=8c2a7c2e&"
import script from "./ViewVisitorModal.vue?vue&type=script&lang=js&"
export * from "./ViewVisitorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports